import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { SubjectService } from '../services/subject.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubjectAccountModalComponent } from '../subject-account-modal/subject-account-modal.component';
import { ModalsComponent } from '../modals/modals.component';
import { MatTableDataSource, MatSort, MatPaginator, MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { Subject } from '../subject/subject.component';

export interface Account {
  id: number;
  subject_id: number;
  bank: string;
  bic: string;
  iban: string;
  currency: string;
}

@Component({
  selector: 'app-subject-insert',
  templateUrl: './subject-insert.component.html',
  styleUrls: ['./subject-insert.component.css']
})
export class SubjectInsertComponent implements OnInit {
  id: number;
  name: string;
  eik: number;
  dds: number;
  address: string;
  city: string;
  mol: string;
  accounts: any;
  columnsToDisplay: any;
  displayedColumns: any;
  dataSource: any;
  selection: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private subjectService: SubjectService,
    public dialog: MatDialog,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private location: Location,
    public dialogRef: MatDialogRef<SubjectInsertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Subject,
    private router: Router) {
    // const id = +this.route.snapshot.paramMap.get('id');
    this.id = 0; // beshe  == id
    //   console.log(id);
    // if (id != 0) {
    //   this.getAccounts(id);
    //   this.editSubject(id);
    // } else {
    //   this.getAccounts(0);
    //   this.dds = 0;
    // }
  
    
    if (data.id) {
      this.getAccounts(data.id);
      this.id = data.id;
    } else {
      this.getAccounts(0);
      data.dds = 0;
    }
  }

  ngOnInit() {
  }


  closeModal() {
    if(this.dialogRef){
      this.dialogRef.close();
    }
    
  }

  submit(subjectForm) {
    const id = +this.route.snapshot.paramMap.get('id');
    // if (id == 0) {
    //   this.subjectService.saveSubject(subjectForm).subscribe(data => {
    //     // this.subjectService.getSubjects();
    //     // this.router.navigate(['/subjects']);
    //   });
    // } else {
    //   this.subjectService.updateSubject(subjectForm, id).subscribe(data => {
    //     // this.subjectService.getSubjects();
    //     // this.router.navigate(['/subjects']);

    //   });

    if (this.id == 0) {
      this.subjectService.saveSubject(subjectForm).subscribe(data => {
        this.dialogRef.close();
      });
    } else {
      console.log(this.id,subjectForm);
      this.subjectService.updateSubject(subjectForm, this.id).subscribe(data => {
        this.dialogRef.close();
      });



    }

  }


  deleteModal(id, component): void {
    const dialogRef = this.dialog.open(ModalsComponent, {
      width: '250px',
      data: { id: id, component: component }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAccounts(this.id);

    });
  }


  editSubject(id) {
    this.subjectService.editSubject(id).subscribe(data => {
      this.name = data.name,
        this.eik = data.eik,
        this.address = data.address,
        this.city = data.city,
        this.dds = data.dds,
        this.mol = data.mol
    });
  }


  getAccounts(id) {
    this.subjectService.getAccounts(id).subscribe(data => {
      this.accounts = data,
      this.displayedColumns = ['bank', 'bic', 'iban', 'currency', 'actions']
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Account>(this.accounts);
      this.selection = new SelectionModel<Account>(true, []);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;

    });
    return this.accounts;
  }

  openDialog(id): void {
    console.log(id);
    if (id != 0) {
      this.subjectService.editAccount(id).subscribe(data1 => {
        console.log(data1);
        const dialogRef = this.dialog.open(SubjectAccountModalComponent, {
          width: '600px',
          data: {
            bank: data1.bank,
            bic: data1.bic,
            iban: data1.iban,
            currency: data1.currency,
            subject_id: data1.subject_id,
            default: data1.default
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log(result);

          if (result != undefined) {
            console.log(id);
            this.subjectService.editSubjectAccount(result, id).subscribe(data => {
              this.getAccounts(this.id);
            });
          }
        });
      });
    } else {
      const dialogRef = this.dialog.open(SubjectAccountModalComponent, {
        width: '600px',
        data: {
          bank: '',
          bic: '',
          iban: '',
          currency: '',
          subject_id: this.id,
          default: false,
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.subjectService.saveSubjectAccount(result).subscribe(data => {
            this.getAccounts(this.id);
          });
        }
      });
    }
  }

}
